import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../api.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { coursePeriod } from '../courses/period.js'

// Teacher landing: my courses + shortcut to the by-date attendance view.

export function TeacherCoursesPage() {
  const { t } = useTranslation()
  const { user, loading: authLoading } = useAuth()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const allowed = user && (user.role === 'teacher' || user.role === 'admin')

  useEffect(() => {
    if (authLoading || !allowed) return
    api.teacher.courses()
      .then((d) => setRows(d.courses || []))
      .catch((e) => setError(e.code || 'server'))
      .finally(() => setLoading(false))
  }, [authLoading, allowed])

  if (authLoading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!allowed) {
    return <main className="container"><p className="error">{t('teacher.errors.not_teacher')}</p></main>
  }

  return (
    <main className="container">
      <h1>{t('teacher.title')}</h1>
      <p className="muted">{t('teacher.intro')}</p>
      <p><Link to="/teacher/attendance">{t('teacher.attendance_by_date')}</Link></p>

      {error && <p className="error">{t(`teacher.errors.${error}`, { defaultValue: error })}</p>}
      {loading && <p>{t('common.loading')}</p>}
      {!loading && rows.length === 0 && <p className="muted">{t('teacher.empty_state')}</p>}

      {!loading && rows.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>{t('teacher.col_course')}</th>
              <th>{t('teacher.col_type')}</th>
              <th>{t('teacher.col_period')}</th>
              <th>{t('teacher.col_enrolled')}</th>
              <th>{t('teacher.col_actions')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id}>
                <td>
                  <Link to={`/teacher/courses/${c.id}`}>{c.name}</Link>
                  {c.active !== 1 && <span className="muted small"> ({t('teacher.inactive')})</span>}
                  {user.role === 'admin' && c.teacher_name && (
                    <><br /><span className="muted small">{c.teacher_name}</span></>
                  )}
                </td>
                <td>{t(`admin_courses.type_${c.type}`, { defaultValue: c.type })}</td>
                <td className="small">{coursePeriod(t, c.date_start, c.date_end) || t('courses.always_open')}</td>
                <td>{c.capacity !== null ? `${c.enrolled_count}/${c.capacity}` : c.enrolled_count}</td>
                <td>
                  {(c.type === 'hourly' || c.type === 'sessions') && c.managed !== 'self' && (
                    <Link to={`/teacher/courses/${c.id}/attendance`}>{t('teacher.attendance')}</Link>
                  )}
                  {user.role === 'admin' && c.managed === 'bbso' && (
                    <Link to={`/admin/courses/${c.id}/participants`} style={{ marginLeft: '0.5rem' }}>
                      {t('teacher.manage_participants')}
                    </Link>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  )
}
